const queries = {
  terminationList: () => ['terminations'],
  termination: (id: number) => ['terminations', id],
  terminationSetup: () => ['terminations/setup'],
}

export default queries
